import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  signal,
  TemplateRef,
  ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IGolfSourceService } from '../../../services/IGolfCourse/igolf-source.service';
import {
  GolfCourse,
  Hole,
  ScoreCardResponse,
  VectorGPSResponse,
} from '../../../model/igolf.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../shared/services/shared.service';
import { customSettings, User } from '../../../model/user.model';
import { MediaService } from '../../../services/media.service';
import { CommonModule, DatePipe, DecimalPipe, isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { MapService } from '../../../services/map/map.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { AskQuestionModel, chat, message } from '../../../model/chat.model';
import { finalize, forkJoin, shareReplay, switchMap } from 'rxjs';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { ChatService } from '../../../services/chat/chat.service';
import { AnalyticsService, AnalyticsEvent } from '../../../services/analytics.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../shared/components/confirmation/confirmation.component';
import { FormatChatPipe } from '../../../pipes/format-chat/format-chat.pipe';
import { UserSettingService } from '../../../services/user-setting.service';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { FormsModule } from '@angular/forms';
import { CaddyService } from '../../../services/caddy.service';
import { Caddy } from '../../../model/caddy.model';
import { v4 as uuidv4 } from 'uuid';
import {
  DragScrollComponent,
  DragScrollItemDirective,
} from 'ngx-drag-scroll';
import { RuleAssistModalComponent } from '../../../shared/components/rule-assist-modal/rule-assist-modal.component';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-in-play',
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe,
    FormatChatPipe,
    LottieComponent,
    DragScrollComponent,
    DragScrollItemDirective,
    RuleAssistModalComponent,
    NgOptimizedImage,
  ],
  providers: [TranslatePipe, DecimalPipe, DatePipe],
  templateUrl: './in-play.component.html',
  styleUrl: './in-play.component.scss',
})
export class InPlayComponent implements OnInit, OnDestroy {
  course: GolfCourse = new GolfCourse();
  id = '';
  user = signal<User>({} as User);
  isGpsEnabled = false;
  speaking = signal(false);
  private mediaRecorder: MediaRecorder | null = null;
  private audioChunks: Blob[] = [];
  audioUrl: string | undefined | null;
  audioBlob: Blob | undefined;
  questionModel: AskQuestionModel = new AskQuestionModel();
  audioQueue: string[] = [];
  isPlaying = signal(false);
  private audio!: HTMLAudioElement;
  chatId: string = '';
  isProcessing = signal(false);
  aiSpeaking = signal(false);
  isBrowser = false;
  answerEnd = signal(true);
  mediaStream: MediaStream | null = null;
  activeVoiceChunk = '';
  voiceChunks = 0;
  recordingTimer: ReturnType<typeof setTimeout> | undefined;
  holeNumbers: number[] = [];
  changeUnitModalRef: NgbModalRef | null = null;
  // Earth radius in yards
  private readonly EARTH_RADIUS_YARDS = 3959 * 1760;
  userLatitude: number = 0;
  userLongitude: number = 0;
  watchId: number | null = null;
  position: GeolocationCoordinates | null = null;
  accuracy: number | null = null;
  holes: Hole[] = [];
  currentHole: Hole = new Hole();
  centerDistance = 0;
  playedHoles: Hole[] = [];
  upcomingHoles: Hole[] = [];
  // unit = 'yard';
  vectorData = {} as VectorGPSResponse;
  conversations: {
    answer: string;
    question: string;
    loading: boolean;
    id: string;
    reaction: string;
    refId?: string;
    route?: string;
  }[] = [];

  submitting = signal(false);
  buffer: string = '';
  textQuestion = '';
  isLoading = signal(false);
  isCallCaddy = signal(false);
  isVoiceToVoiceChat = signal(false);
  voiceAnswerEnd = signal(false);
  scoreCardData = new ScoreCardResponse();
  private endRoundClicked = false;
  lastScrollTop: number = 0; // Stores the last scrollTop value
  isMuted = signal(false);
  customSetting: customSettings = {
    general: '',
    onCourse: '',
    distance: 'yards',
    onCourseMode: '',
    onCourseAudio: '',
  };
  loadingCourseData = signal(false);
  loadingMessage = signal(false);
  animationOptions: AnimationOptions = {
    path: '/assets/animations/New_AI_Processing.json',
  };
  isInitial = signal(false);
  retryDelay = 500;
  // loadingMichrophone = false;
  accuracyList: { accuracy: number; latitude: number; longitude: number }[] = [];
  findingLocation = false;
  caddieSettingsModalRef: NgbModalRef | null = null;
  isCustomSettingSaving = false;
  currentMode = '';
  caddy: Caddy | null = null;
  // caddyName = '';

  manualTextQuestion: string = '';
  isActive = false;
  processingOptions: AnimationOptions = {
    path: '/assets/animations/New_AI_Processing.json',
  };
  talkingOptions: AnimationOptions = {
    path: '/assets/animations/New_AI_Talking.json',
  };
  listeningOptions: AnimationOptions = {
    path: '/assets/animations/New_AI_Listening.json',
  };
  toggleActive() {
    this.isActive = !this.isActive;
  }
  openVoiceToVoiceChat = signal(false);
  answerListening = signal(false);
  audioAnswerLoading = signal(false);
  playingIndex = 0;
  showTextQuestionControl = signal(false);
  settingModalRef: NgbModalRef | null = null;
  ruleAssistQuestionObject!: chat;
  mediaElementSource: MediaElementAudioSourceNode | null = null;
  @ViewChild('equalizerCanvas', { static: true })
  canvasRef!: ElementRef<HTMLCanvasElement>;
  private ruleAssistModalRef!: NgbModalRef;
  @ViewChild('audioRef') audioRef!: ElementRef<HTMLAudioElement>;
  @ViewChild('myInput') myInput!: ElementRef<HTMLTextAreaElement>;
  base64Audio: string | null = null;
  showEqualizer = signal(false);
  recordingFinished = signal(false);
  audioContext!: AudioContext | null;
  isRecording = signal(false);
  recordingStatus: string = 'Not recording';
  analyser!: AnalyserNode;
  dataArray!: Uint8Array<ArrayBuffer>;
  animationFrameId: number = 0;
  isAudioPlaying = signal(false);
  isAnimating = signal(false);
  submittingAudio = signal(false);
  keyboardOpen = signal(false);
  private iGolfSourceService = inject(IGolfSourceService);
  private _activatedRoute = inject(ActivatedRoute);
  private _sharedService = inject(SharedService);
  private _mapService = inject(MapService);
  private _toasterService = inject(ToasterService);
  private platformId = inject<object>(PLATFORM_ID);
  private _translatePipe = inject(TranslatePipe);
  private _toaster = inject(ToasterService);
  private _mediaService = inject(MediaService);
  private _chatService = inject(ChatService);
  private _analytics = inject(AnalyticsService);
  private _modalService = inject(NgbModal);
  private _router = inject(Router);
  private _userSettingService = inject(UserSettingService);
  private _caddyService = inject(CaddyService);
  private _decimalPipe = inject(DecimalPipe);
  private _cdr = inject(ChangeDetectorRef);
  private _ngZone = inject(NgZone);
  private _destroyRef = inject(DestroyRef);

  constructor() {
    this._sharedService.loading.set(false);
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
      this.audio = new Audio();
    }
    this.id = this._activatedRoute.snapshot.paramMap.get('id') || '';
    localStorage.setItem('onCourseId', this.id);
  }

  ngOnInit() {
    this.isLoading.set(true);
    this.isInitial.set(true);
    // if(this.todaysDate === this.eventDate){
    //   this.getCaddyById('67358cecd7d4862aa89b2d55');
    // }
    if (isPlatformBrowser(this.platformId)) {
      if ('geolocation' in navigator) {
        this.watchId = navigator.geolocation.watchPosition(
          (pos) => {
            this.accuracy = pos.coords.accuracy;
            this.userLatitude = pos.coords.latitude;
            this.userLongitude = pos.coords.longitude;

            if (this.isInitial()) {
              this.isLoading.set(false);
              this.isGpsEnabled = true;
              this.isInitial.set(false);
              this.loadData();
            } else {
              this.updateCenterDistance();
            }
          },
          (error) => {
            this.handleLocationError(error);
          },
          {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: 60000,
          }
        );
      } else {
        this.isLoading.set(false);
        this._toaster.error(
          this._translatePipe.transform('LocationErrorMessage'),
          this._translatePipe.transform('LocationErrorTitle')
        );
      }
    }
    this.connectWebSocket();
    this._sharedService.user$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((res) => {
      this.user.set(res);
      if (this.user().image || (this.user().caddy && this.user().caddy.image)) {
        let images: string[] = [];
        const mapping: { key: 'user' | 'caddy'; index: number }[] = [];
        if (this.user().image) {
          mapping.push({ key: 'user', index: images.length });
          images.push(this.user().image);
        }

        if (this.user().caddy?.image) {
          mapping.push({ key: 'caddy', index: images.length });
          images.push(this.user().caddy.image);
        }

        if (images.length > 0) {
          this._mediaService.getMedia(images)
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe((res) => {
            mapping.forEach(({ key, index }) => {
              if (key === 'user') {
                this.user.update(u => ({...u, imageUrl: res[index]?.url || ''}));
              } else if (key === 'caddy') {
                this.user.update(u => ({...u, caddy: {...u.caddy!, imageUrl: res[index]?.url || ''}}));
              }
            });
            this._cdr.detectChanges();
          });
        }
      }
      if (this.user().customSettings) {
        this.customSetting = this.user().customSettings!;
      }
      this._cdr.detectChanges();
    });

    // this.messageSubscription.add(
    //   this._chatService.checkOnlockCaddyFeature().subscribe((res) => {
    //     if (this.id === res.courseId) {
    //       this.caddyName = res.name;
    //     }
    //   })
    // );
    this._chatService.getMessages()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((res) => {
        switch (res.event) {
          case 'ANSWER_CHAT_ID':
            this.chatId = res.data as string;
            localStorage.setItem('OnCourseChatId', this.chatId);
            break;
          case 'AUDIO_TO_TEXT':
            this.manualTextQuestion = (res.data as string).trim();
            this.showTextQuestionControl.set(true);
            this.submittingAudio.set(false);
            this.scrollToBottom();
            this.closeRecording();
            this.submittingAudio.set(false);
            break;
          // case 'AUDIO_TO_TEXT':
          //   this.textQuestion = res.data;
          //   this.conversations.push({
          //     question: this.textQuestion,
          //     id: '',
          //     answer: '',
          //     loading: true,
          //     reaction: 'none',
          //   });
          //   this.sendAudioToTextQuestion();
          //   this._cdr.detectChanges();
          //   break;
          case 'ANSWER_START':
            this.audioQueue = [];
            this.activeVoiceChunk = '';
            this.voiceChunks = 0;
            this.answerEnd.set(false);
            this.isProcessing.set(false);
            this.submitting.set(false);
            this._cdr.detectChanges();
            this.buffer = '';
            if (
              this.customSetting.onCourseAudio === 'on' ||
              this.isVoiceToVoiceChat()
            ) {
              this.aiSpeaking.set(true);
            } else {
              this.isMuted.set(true);
            }
            this._cdr.detectChanges();
            break;
          case 'ROUTE_INFO':
            this.conversations[this.conversations.length - 1].route = res.data as string;
            this._cdr.markForCheck();
            break;
          case 'ANSWER_VOICE_CHUNK':
            if (
              this.customSetting.onCourseAudio === 'on' ||
              this.isVoiceToVoiceChat()
            ) {
              this.activeVoiceChunk += res.data;
            }
            break;
          case 'ANSWER_VOICE_CHUNK_END':
            if (this.activeVoiceChunk) {
              this.voiceChunks++;
              this.audioQueue.push(this.activeVoiceChunk);
              this.activeVoiceChunk = '';
              this.playNextInQueue();
            }
            break;
          case 'ANSWER_TEXT_CHUNK':
            this.buffer += res.data;
            // this.submitting = false;
            this.updateMessages(this.buffer);
            break;
          case 'ANSWER_ID':
            this.conversations[this.conversations.length - 1].id = res.data as string;
            this._cdr.markForCheck();
            break;
          case 'ANSWER_END':
            this.answerEnd.set(true);
            this.voiceChunks = 0;
            if (!this.aiSpeaking()) {
              this.isVoiceToVoiceChat.set(false);
              this.isCallCaddy.set(false);
              this.isMuted.set(false);
            }
            this._cdr.markForCheck();
            this.playNextInQueue();
            break;
          case 'ANSWER_ERROR':
            this.isProcessing.set(false);
            this.aiSpeaking.set(false);
            this.submitting.set(false);
            this.isMuted.set(false);
            this._cdr.detectChanges();
            this.isVoiceToVoiceChat.set(false);
            this._toaster.error(
              res.data as string,
              this._translatePipe.transform('Error')
            );
            break;
          default:
        }
      });
    this._chatService.audioEnded()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((res) => {
        if (res === true) {
          this.answerListening.set(false);
        } else if (res === false) {
          this.audioAnswerLoading.set(false);
          this._cdr.markForCheck();
        }
      });
  }
  updateMessages(message: string) {
    this.conversations[this.conversations.length - 1].loading = false;
    this.conversations[this.conversations.length - 1].answer = message.replace(
      /\n/g,
      '<br>'
    );
    this.scrollToBottom();
    this._cdr.markForCheck();
  }
  async enableLocation(): Promise<void> {
    const gpsEnabled = await this._mapService.checkIfGpsEnabled();
    if (!gpsEnabled) {
      this._toasterService.warning(
        this._translatePipe.transform('LocationEnableMessage'),
        this._translatePipe.transform('Info')
      );
    } else {
      this.isGpsEnabled = true;
    }
  }
  watchLocation() {
    const options = {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeOut: 60000,
    };
    this.watchId = navigator.geolocation.watchPosition(
      (pos) => {
        if (this.userLatitude && this.userLongitude) {
          // const distance = this.calculateDistance(
          //   this.userLatitude,
          //   this.userLongitude,
          //   pos.coords.latitude,
          //   pos.coords.longitude,
          //   'meters'
          // );
          this.accuracy = pos.coords.accuracy;
          if (this.accuracy != null && this.accuracy < 5) {
            this.userLatitude = pos.coords.latitude;
            this.userLongitude = pos.coords.longitude;
            this.updateCenterDistance();
          }
        }
      },
      (error) => {
        // this.isLoading = false;
        // this.isGpsEnabled = false;
        this.handleLocationError(error);
      },
      options
    );
  }

  private handleLocationError(error: GeolocationPositionError): void {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        this._toaster.error(
          this._translatePipe.transform('LocationDenied'),
          this._translatePipe.transform('Error')
        );
        break;
      case error.POSITION_UNAVAILABLE:
        this._toaster.error(
          this._translatePipe.transform('LocationInfoUnavailable'),
          this._translatePipe.transform('Error')
        );
        break;
      case error.TIMEOUT:
        this._toaster.error(
          this._translatePipe.transform('LocationTimeout'),
          this._translatePipe.transform('Error')
        );
        break;
      default:
        this._toaster.error(
          this._translatePipe.transform('UnknownError'),
          this._translatePipe.transform('Error')
        );
        break;
    }
  }

  loadData() {
    // this.getCourse();
    // this.getTees();
    // this.getGPSDetail();
    this.getCourseData();
    this.chatId = localStorage.getItem('OnCourseChatId') ?? '';
    if (this.chatId) {
      this.getMessagesFromId();
    }
  }
  getCourse() {
    this.iGolfSourceService.getCourseDetailFromId(this.id)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (res) => {
          this.course = res;
          this._cdr.markForCheck();
        },
      });
  }
  getCourseScoreCard() {
    this.iGolfSourceService.getCourseScoreCard(this.id)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (res) => {
          // console.log('ScoreCard:' + res);
        },
      });
  }
  getGPSDetail() {
    this.iGolfSourceService.getGpsDetail(this.id)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (res) => {
          // console.log('GpsDetail:' + res);
        },
      });
  }
  getCourseData() {
    this.loadingCourseData.set(true);
    const gpsVector$ = this.iGolfSourceService
      .getGpSVector(this.id)
      .pipe(shareReplay(1));
    const scoreCard$ = this.iGolfSourceService
      .getCourseScoreCard(this.id)
      .pipe(shareReplay(1));
    const course$ = this.iGolfSourceService
      .getCourseDetailFromId(this.id)
      .pipe(shareReplay(1));
    forkJoin({ gpsVector: gpsVector$, scoreCard: scoreCard$, course: course$ })
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        finalize(() => {
          this.loadingCourseData.set(false);
        })
      )
      .subscribe((res) => {
        this.scoreCardData = res.scoreCard;
        this.vectorData = res.gpsVector;
        this.course = res.course;
        if (!this.isEmpty(this.vectorData.vectorGPSObject)) {
          for (
            let i = 0;
            i < this.vectorData.vectorGPSObject.Holes.Hole.length;
            i++
          ) {
            const mensPar = this.scoreCardData.menScorecardList[0].parHole[i];
            const wmnPar = this.scoreCardData.wmnScorecardList[0].parHole[i];
            this.holes.push({
              hole: this.vectorData.vectorGPSObject.Holes.Hole[i],
              par:
                mensPar == wmnPar ? mensPar.toString() : mensPar + '/' + wmnPar,
            });
          }
          const storedHoleNumber = localStorage.getItem('HoleNumber');
          this.upcomingHoles = [...this.holes];
          if (storedHoleNumber) {
            this.currentHole =
              this.holes.find((x) => x.hole.HoleNumber == +storedHoleNumber) ??
              this.holes[0];
            if (this.currentHole.hole.HoleNumber == this.holes.length) {
              this.playedHoles = [
                this.holes.find(
                  (x) => x.hole.HoleNumber == +storedHoleNumber - 1
                )!,
              ];
              this.upcomingHoles = [...this.holes];
            } else if (
              this.currentHole.hole.HoleNumber === this.holes[0].hole.HoleNumber
            ) {
              this.playedHoles = [this.upcomingHoles.pop()!];
              this.upcomingHoles.shift();
            } else {
              const playedHoles = this.upcomingHoles.splice(
                0,
                +storedHoleNumber - 1
              );
              this.playedHoles = playedHoles.reverse();
              this.upcomingHoles.shift();
            }
          } else {
            this.currentHole = this.upcomingHoles.shift()!;
            this.playedHoles = [this.upcomingHoles.pop()!];
          }
          // localStorage.setItem("HoleNumber", this.currentHole.hole.HoleNumber.toString());
          const greenCetner =
            this.currentHole.hole.Greencenter?.Shapes?.Shape[0]?.Points.split(
              ' '
            );
          // console.log(
          //   'CourseUser_LatLon:',
          //   this.userLatitude,
          //   this.userLongitude
          // );
          this.centerDistance = this.calculateDistance(
            this.userLatitude,
            this.userLongitude,
            +greenCetner[1],
            +greenCetner[0],
            this.customSetting.distance
          );
        }
        this._cdr.markForCheck();
      });
  }
  updateCenterDistance() {
    if (this.currentHole) {
      const greenCetner =
        this.currentHole.hole.Greencenter?.Shapes?.Shape[0]?.Points.split(' ');
      if (greenCetner) {
        this.centerDistance = this.calculateDistance(
          this.userLatitude,
          this.userLongitude,
          +greenCetner[1],
          +greenCetner[0],
          this.customSetting.distance
        );
        this._cdr.detectChanges();
      }
    }
  }

  isEmpty(obj: object | null | undefined): boolean {
    return !obj || Object.keys(obj).length === 0;
  }

  getTees() {
    this.iGolfSourceService.getTees(this.id)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (res) => {
          // console.log('Tees', res);
        },
      });
  }
  submitAudioQuestion() {
    this.buffer = '';
    // call api
    if (!this.audioBlob) {
      return this._toaster.error(
        this._translatePipe.transform('AudioRequired'),
        this._translatePipe.transform('Error')
      );
    }
    if (this.audio) {
      this.audio.pause();
      this.audio.src = '';
      this.audio.load();
    }
    // this.submitting = true;
    this.getUsersLatestLocation();
    const fileName = this.generateUniqueFileName();
    let uploadedUrl: string | undefined;
    this._mediaService
      .getMediaUrls(fileName)
      .pipe(
        switchMap((response1) => {
          uploadedUrl = response1[0].get?.url;
          return this._mediaService.uploadMediaToS3(
            response1[0].put?.url!,
            this.audioBlob!
          );
        }),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe({
        next: (res) => {
          this.audioBlob = undefined;
          this.closeRecording();
          this._chatService.voiceToText(uploadedUrl);
        },
      });
  }

  stopRecording() {
    if (this.mediaRecorder && this.isRecording()) {
      this.mediaRecorder.stop(); // triggers `onstop` where cleanup already happens
      this.isRecording.set(false);
      this.recordingFinished.set(true);
      this.recordingStatus = 'Not recording';
      this.submittingAudio.set(true);
      // Note: submitAudioQuestion() is now called in the onstop handler after audioBlob is ready
    }

    // Ensure we stop the visualizer animation
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }

    // Close audio context if still open
    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close();
    }
  }
  stopTalking() {
    this.aiSpeaking.set(false);
    if (!this.answerEnd()) {
      this.isMuted.set(true);
    }
    if (this.answerEnd()) {
      this.isVoiceToVoiceChat.set(false);
      this.isCallCaddy.set(false);
    }
    this.stopAudio();
  }

  startTalking() {
    this.aiSpeaking.set(true);
    this.isMuted.set(false);

    this.playNextInQueue();
  }
  playNextInQueue(): void {
    if (!this.aiSpeaking()) return;
    if (this.isPlaying() || this.audioQueue.length === 0) {
      if (this.audioQueue.length === 0 && this.answerEnd()) {
        this.aiSpeaking.set(false);
        this.isMuted.set(false);
        this.isCallCaddy.set(false);
        this.isVoiceToVoiceChat.set(false);
        this.isMuted.set(false);
        this._cdr.detectChanges(); // Ensure the view updates
      }
      return;
    }
    const nextAudioUrl = this.audioQueue.shift();
    if (nextAudioUrl) {
      let blob = this.base64ToBlob(nextAudioUrl);
      let audioUrl = URL.createObjectURL(blob);
      this.playAudio(audioUrl);
    }
  }
  playAudio(audioUrl: string): void {
    this.isPlaying.set(true);
    this.audio.src = audioUrl;
    this.audio.load();
    this.audio
      .play()
      .then(() => {})
      .catch((error: unknown) => {
        this.isPlaying.set(false);
        this.playNextInQueue(); // Try to play the next in queue
      });

    this.audio.onended = () => {
      this.isPlaying.set(false);
      this.playNextInQueue(); // Play the next audio in queue
    };
  }
  stopAudio() {
    this.audio.pause();
    this.audioQueue = [];
    this.isPlaying.set(false);
  }
  generateUniqueFileName(): string {
    const timestamp = Date.now();
    // Generate a random number
    const randomNum = Math.floor(Math.random() * 1e9);
    // Combine timestamp and random number to create a unique identifier
    const uniqueIdentifier = `${timestamp}-${randomNum}`;
    // Construct the unique filename with the file extension
    const uniqueFileName = `${uniqueIdentifier}.mp3`;
    return uniqueFileName;
  }
  base64ToBlob(base64: string): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'audio/wav' });
  }

  callCaddy(): void {
    this._analytics.track(AnalyticsEvent.CADDIE_ADVICE_CLICKED);
    this.isAnimating.set(true);
    this.isCallCaddy.set(true);
    this.findingLocation = true;
    this.accuracyList = []; // Array to store accuracy and coordinates
    const maxDuration = 6000; // 6 seconds
    const startTime = Date.now();
    setTimeout(() => {
      this.isAnimating.set(false);
    }, 1500); // animation duration in ms
    const checkAccuracy = () => {
      if (this.accuracy != null) {
        // Check if the accuracy value already exists in the list
        const exists = this.accuracyList.some(
          (entry) => entry.accuracy === this.accuracy
        );
        if (!exists) {
          // Store accuracy with corresponding coordinates
          this.accuracyList.push({
            accuracy: this.accuracy,
            latitude: this.userLatitude,
            longitude: this.userLongitude,
          });
        }
      }
      // If accuracy is below the threshold, proceed
      if (this.accuracy != null && this.accuracy < 5) {
        this.findingLocation = false;
        this._cdr.markForCheck();
        this.callCaddyLogic(this.userLatitude, this.userLongitude); // Execute the main logic
        return;
      }
      // Check if the maximum duration is exceeded
      if (Date.now() - startTime > maxDuration) {
        // Find the lowest accuracy value in the stored data
        const bestEntry = this.accuracyList.reduce((best, current) => {
          return current.accuracy < best.accuracy ? current : best;
        });
        // Use the best accuracy and its coordinates
        this.findingLocation = false;
        this._cdr.markForCheck();
        this.callCaddyLogic(bestEntry.latitude, bestEntry.longitude); // Execute the main logic with the best data
        return;
      }
      // Retry if the duration is within the limit
      setTimeout(checkAccuracy, this.retryDelay);
    };
    checkAccuracy();
  }

  callCaddyLogic(
    lat: number,
    lon: number,
    manualTextQuestion: string = ''
  ): void {
    this.buffer = '';
    // this.isCallCaddy = true;
    this.answerEnd.set(false);
    this.submitting.set(true);
    this.questionModel = new AskQuestionModel();
    this.questionModel.chatId = this.chatId;

    // Use data from watchPosition
    this.questionModel.clientLocation = `${lat},${lon}`;
    this.questionModel.holeNumber = this.currentHole.hole.HoleNumber;
    this.questionModel.courseId = this.id;

    // Calculate Distance
    const greenCenter =
      this.currentHole.hole.Greencenter?.Shapes?.Shape[0]?.Points.split(' ');

    this.centerDistance = this.calculateDistance(
      lat,
      lon,
      +greenCenter[1],
      +greenCenter[0],
      this.customSetting.distance
    );
    if (manualTextQuestion) {
      this.questionModel.processType = 'QA-ON-COURSE';
      this.questionModel.textQuestion = manualTextQuestion;
    } else {
      const textQuestion = `${this._translatePipe.transform(
        'CallCaddyQuestion'
      )} ${this.currentHole.hole.HoleNumber} - ${this._decimalPipe.transform(
        this.centerDistance,
        '1.0-0'
      )} ${
        this.customSetting.distance === 'yards'
          ? this._translatePipe.transform('Y')
          : this._translatePipe.transform('M')
      } ${this._translatePipe.transform('CallCaddyQuestionEnd')}`;

      this.questionModel.processType = 'QA-ON-COURSE-CADDY';
      this.questionModel.textQuestion = `Caddie Advice - Hole ${
        this.currentHole.hole.HoleNumber
      } - ${this._decimalPipe.transform(this.centerDistance, '1.0-0')} ${
        this.customSetting.distance === 'yards'
          ? this._translatePipe.transform('Y')
          : this._translatePipe.transform('M')
      } to the hole`;
      this.conversations = [
        ...this.conversations,
        {
          question: textQuestion,
          id: '',
          answer: '',
          loading: true,
          reaction: 'none',
        },
      ];
    }

    // Make the API Call
    this._chatService.askQuestionV2(this.questionModel);

    this.scrollToBottom();
    this._cdr.detectChanges();
  }

  connectWebSocket() {
    if (isPlatformBrowser(this.platformId)) {
      this._ngZone.runOutsideAngular(() => {
        this._chatService
          .onListenWebsocket()
          .then(() => {
            // socket connected succefully .
          })
          .catch((error) => {
            this._toaster.error(
              this._translatePipe.transform('SocketConnectionError'),
              this._translatePipe.transform('Error')
            );
            // console.error('Failed to connect to WebSocket:', error);
          });
      });
    }
  }

  reinitializeWebSocket(): void {
    this._chatService.disconnectWebSocket();
    this.connectWebSocket();
  }
  nextHole() {
    // Check if there is only 1 upcoming hole left
    if (this.upcomingHoles.length == 1) {
      // Move the current hole into played holes
      this.playedHoles = [this.currentHole];
      // Set the last upcoming hole as the new current hole
      this.currentHole = this.upcomingHoles[0];
      // Reset the upcoming holes back to the full holes list
      this.upcomingHoles = [...this.holes];
      localStorage.setItem(
        'HoleNumber',
        this.currentHole.hole.HoleNumber.toString()
      );
    } else {
      // Check if this is the very first hole transition
      if (this.upcomingHoles.length == this.holes.length) {
        // Remove the last hole from played holes (if any)
        this.playedHoles.pop();
        this.playedHoles = [this.currentHole];
        // Move the first upcoming hole into current hole
        this.currentHole = this.upcomingHoles.shift()!;
      } else {
        // Add the current hole to the beginning of the played holes list
        this.playedHoles.unshift(this.currentHole);
        // Move the first upcoming hole into current hole
        this.currentHole = this.upcomingHoles.shift()!;
      }
      localStorage.setItem(
        'HoleNumber',
        this.currentHole.hole.HoleNumber.toString()
      );
      // Extract green center coordinates from hole data
      const greenCetner =
        this.currentHole.hole.Greencenter.Shapes.Shape[0].Points.split(' ');
      // Calculate distance from user's location to green center
      this.centerDistance = this.calculateDistance(
        this.userLatitude,
        this.userLongitude,
        +greenCetner[1],
        +greenCetner[0],
        this.customSetting.distance
      );
      this._cdr.detectChanges();
    }
  }
  prevHole() {
    const lastHoleNumber = this.holes.length;
    const prevHoleNumber =
      this.currentHole.hole.HoleNumber - 1 <= 0
        ? lastHoleNumber
        : this.currentHole.hole.HoleNumber - 1;

    // If the previous hole is actually the last hole number
    if (prevHoleNumber === lastHoleNumber) {
      // Set current hole to the last hole
      this.currentHole = this.holes[lastHoleNumber - 1];

      // Upcoming holes start from hole 1 onward
      this.upcomingHoles = [...this.holes];

      // Played holes is just the one before the last hole
      this.playedHoles = [this.holes[lastHoleNumber - 2]];
    } else {
      // Normal prevHole behavior
      this.upcomingHoles.unshift(this.currentHole);
      this.currentHole = this.playedHoles.shift()!;
    }

    // Save hole number
    localStorage.setItem(
      'HoleNumber',
      this.currentHole.hole.HoleNumber.toString()
    );
    const greenCetner =
      this.currentHole.hole.Greencenter.Shapes.Shape[0].Points.split(' ');
    this.centerDistance = this.calculateDistance(
      this.userLatitude,
      this.userLongitude,
      +greenCetner[1],
      +greenCetner[0],
      this.customSetting.distance
    );
    this._cdr.detectChanges();
  }
  // Function to convert degrees to radians
  degreesToRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }
  // Function to calculate the distance between two coordinates in yards
  calculateDistance(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
    unit: string
  ): number {
    const R = 6371000; // Radius of the Earth in meters
    const dLat = this.degreesToRadians(lat2 - lat1);
    const dLon = this.degreesToRadians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.degreesToRadians(lat1)) *
        Math.cos(this.degreesToRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let distance = R * c; // Distance in meters by default

    // Convert distance to yards if needed
    if (this.customSetting.distance === 'yards') {
      distance *= 1.09361; // Convert meters to yards (1 meter ≈ 1.09361 yards)
    }
    return distance;
  }
  endRound() {
    const modalRef = this._modalService.open(ConfirmationComponent, {
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.message = 'EndRoundConfirmation';
    modalRef.componentInstance.confirmText = 'EndRound';
    modalRef.componentInstance.cancelText = 'Return';
    modalRef.componentInstance.title = 'ConfirmEndRound';

    modalRef.result.then(
      (result) => {
        if (result) {
          this.endRoundClicked = true;
          this._analytics.track(AnalyticsEvent.END_ROUND);
          // navigate to course list
          this._router.navigate(['/']);
        }
      },
      (reason) => {
        // User dismissed the modal
        // console.log('Action dismissed');
      }
    );
  }

  openChangeUnit(content: TemplateRef<unknown>) {
    this.changeUnitModalRef = this._modalService.open(content, {
      backdrop: 'static',
      centered: true,
    });
  }
  openCaddieSettingsModal(content: TemplateRef<unknown>) {
    this.caddieSettingsModalRef = this._modalService.open(content, {
      backdrop: 'static',
      centered: true,
    });
  }

  changeUnit(type: string) {
    if (type === this.customSetting.distance) {
      this.changeUnitModalRef?.dismiss();
      return;
    } else {
      this.customSetting.distance = type;
      this._userSettingService.customize(this.customSetting)
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe({
        next: (res) => {
          if (type === 'yards') {
            this.centerDistance = +this.centerDistance * 1.09361;
          } else {
            this.centerDistance = +this.centerDistance * 0.9144;
          }
          this.user.update(u => ({...u, customSettings: this.customSetting}));
          this._sharedService.setUser(this.user());
          this.changeUnitModalRef?.dismiss();
          this._cdr.detectChanges();
        },
      });
    }
  }
  getMessagesFromId() {
    this.loadingMessage.set(true);
    this._chatService
      .getMessageFromId(this.chatId, 100, 1)
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        finalize(() => {
          this.loadingMessage.set(false);
        })
      )
      .subscribe({
        next: (res) => {
          res.results = res.results.reverse();
          res.results
            .filter((rs: message) => rs.role === 'assistant')
            .forEach((item: message, index: number) => {
              if (item.role === 'assistant') {
                const questionIndex = res.results.findIndex(
                  (lm: message) => lm.id === item.questionRef
                );
                if (questionIndex !== -1) {
                  this.conversations.push({
                    answer: item.content,
                    question: res.results[questionIndex].content,
                    loading: false,
                    id: res.results[questionIndex].id,
                    reaction: res.results[questionIndex].reaction ?? '',
                  });
                }
              }
            });
        },
      });
  }
  get showCaddyAdvice(): boolean {
    return (
      !this.speaking() &&
      !this.isProcessing() &&
      !this.aiSpeaking() &&
      !this.isMuted() &&
      !this.submitting() &&
      !this.isVoiceToVoiceChat() &&
      !this.findingLocation
    );
  }

  get showProcessing(): boolean {
    return this.isProcessing() || this.submitting();
  }

  get showVoiceBlock(): boolean {
    return (
      !this.speaking() &&
      (!this.aiSpeaking() || !this.isCallCaddy()) &&
      !this.isVoiceToVoiceChat()
    );
  }
  translateOnCourseAdvice1(key: string): string {
    return this._translatePipe
      .transform(key)
      .replace('{userName}', this.user().name)
      .replace('{courseName}', this.course.courseName)
      .replace('{caddieName}', this.caddy?.name ?? '');
  }

  getHoleNumber(key: string, holeNumber: number): string {
    return this._translatePipe
      .transform(key)
      .replace('{number}', holeNumber.toString());
  }
  updateCustomSetting() {
    this.isCustomSettingSaving = true;
    this._userSettingService
      .customize(this.customSetting)
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        finalize(() => {
          this.isCustomSettingSaving = false;
        })
      )
      .subscribe({
        next: (res) => {
          this.user.update(u => ({...u, customSettings: this.customSetting}));
          this._sharedService.setUser(this.user());
          this.caddieSettingsModalRef?.dismiss();
          this._cdr.detectChanges();
        },
      });
  }
  getCaddyById(id: string): void {
    this._caddyService.getById(id)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (res) => {
          this.caddy = res;
          this._cdr.markForCheck();
          if (res.image) {
            this._mediaService.getMedia([res.image])
              .pipe(takeUntilDestroyed(this._destroyRef))
              .subscribe((res) => {
                if (this.caddy) {
                  this.caddy.imageUrl = res[0] ? res[0].url : '';
                  this._cdr.markForCheck();
                }
              });
          }
        },
      });
  }
  sendManualTextQuestion() {
    if (!this.manualTextQuestion.trim()) {
      return this._toaster.error('Please enter a question', 'Error');
    }
    const textQuestion = this.manualTextQuestion.trim();
    this.conversations.push({
      question: textQuestion,
      id: '',
      answer: '',
      loading: true,
      reaction: 'none',
    });
    this.manualTextQuestion = ''; // Clear the input field
    this.submitting.set(true);
    this.findingLocation = true;
    this.scrollToBottom();
    this.accuracyList = []; // Array to store accuracy and coordinates
    const maxDuration = 6000; // 6 seconds
    const startTime = Date.now();
    const checkAccuracy = () => {
      if (this.accuracy != null) {
        // Check if the accuracy value already exists in the list
        const exists = this.accuracyList.some(
          (entry) => entry.accuracy === this.accuracy
        );
        if (!exists) {
          // Store accuracy with corresponding coordinates
          this.accuracyList.push({
            accuracy: this.accuracy,
            latitude: this.userLatitude,
            longitude: this.userLongitude,
          });
        }
      }
      // If accuracy is below the threshold, proceed
      if (this.accuracy != null && this.accuracy < 5) {
        this.findingLocation = false;
        this.showTextQuestionControl.set(false);
        this.callCaddyLogic(
          this.userLatitude,
          this.userLongitude,
          textQuestion
        ); // Execute the main logic
        return;
      }
      // Check if the maximum duration is exceeded
      if (Date.now() - startTime > maxDuration) {
        // Find the lowest accuracy value in the stored data
        const bestEntry = this.accuracyList.reduce((best, current) => {
          return current.accuracy < best.accuracy ? current : best;
        });
        // Use the best accuracy and its coordinates
        this.findingLocation = false;
        this.showTextQuestionControl.set(false);
        this.callCaddyLogic(
          bestEntry.latitude,
          bestEntry.longitude,
          textQuestion
        ); // Execute the main logic with the best data
        return;
      }
      // Retry if the duration is within the limit
      setTimeout(checkAccuracy, this.retryDelay);
    };
    checkAccuracy();
  }
  addReaction(reaction: string, index: number, messageId: string) {
    if (this.conversations[index].reaction === reaction) {
      this.conversations[index].reaction = '';
      reaction = 'none';
    } else {
      this.conversations[index].reaction = reaction;
    }

    this._chatService
      .addReactionTotheMessage(messageId, reaction)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((res) => {
        res;
      });
  }
  hearAnswer(text: string, index: number) {
    if (this.answerListening() && this.playingIndex === index) {
      this.stopListening(index);
      return;
    }
    this.playingIndex = index;
    this.audioAnswerLoading.set(true);
    this.answerListening.set(true);
    const id = uuidv4();
    this.conversations[index].refId = id;
    this._chatService.textToAudio(text, id);
  }
  stopListening(index: number) {
    if (this.conversations[index].refId) {
      this._chatService.stopThisAudio(this.conversations[index].refId);
      this.audioAnswerLoading.set(false);
      this.answerListening.set(false);
    }
  }

  closeVoiceToVoiceChat() {
    this.openVoiceToVoiceChat.set(false);
    this.isVoiceToVoiceChat.set(false);
    this.stopAudio();
  }
  openSettingModal(content: TemplateRef<unknown>) {
    this.settingModalRef = this._modalService.open(content, {
      backdrop: 'static',
      centered: true,
    });
  }
  saveSettings() {
    this._userSettingService.customize(this.customSetting)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
      next: (res) => {
        this.user.update(u => ({...u, customSettings: this.customSetting}));
        this._sharedService.setUser(this.user());
      },
    });
  }
  closeSettingsModal() {
    this.settingModalRef?.dismiss();
  }
  openRuleAssistModal(content: TemplateRef<unknown>, index: number) {
    this.ruleAssistQuestionObject = this.conversations[index];
    this.ruleAssistModalRef = this._modalService.open(content, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-rule-assist',
    });
  }
  closeRuleAssistModal() {
    this.ruleAssistModalRef?.dismiss();
  }
  showTextQuestionControlInput() {
    this.showTextQuestionControl.set(true);
    this.manualTextQuestion = '';
    this._cdr.detectChanges();
    if(window.innerWidth <= 991){
      setTimeout(() => {
        const el = this.myInput?.nativeElement as HTMLTextAreaElement;
        if (el) {
          el.click();
          el.focus();
          setTimeout(() => this.scrollToBottom(), 200);
        }
      }, 300);
    }
  }
  scrollInputIntoView() {
       setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
        }, 300);
    // setTimeout(() => {
    //   this.myInput?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    // }, 300);
  }
  hideTextQuestionControl() {
    setTimeout(() => {
      this.showTextQuestionControl.set(false);
      this.manualTextQuestion = '';
      this._cdr.detectChanges();
    }, 200); // Delay to allow click on related elements
  }
  async startRecording() {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    // Setup MediaRecorder (optional for recording)
    this.mediaRecorder = new MediaRecorder(stream);
    this.audioChunks = [];
    this.base64Audio = null;

    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) this.audioChunks.push(event.data);
    };

    this.mediaRecorder.onstop = () => {
      this.audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
      this.audioUrl = URL.createObjectURL(this.audioBlob);
      this.audioRef.nativeElement.src = this.audioUrl;

      const audio = this.audioRef.nativeElement;

      audio.src = this.audioUrl;
      audio.load();
      this._cdr.markForCheck();

      audio.addEventListener(
        'canplaythrough',
        () => {
          this.recordingFinished.set(true);
          // Submit audio question after blob is ready and audio can play
          if (this.submittingAudio()) {
            this.submitAudioQuestion();
          }
        },
        { once: true }
      ); // <- This ensures it only runs once
      // this.convertToBase64(audioBlob);
      stream.getTracks().forEach((track) => track.stop());
      if (this.audioContext && this.audioContext.state !== 'closed') {
        this.audioContext
          .close()
          .catch((err) => console.error('Error closing AudioContext:', err));
      }
      cancelAnimationFrame(this.animationFrameId);
    };

    this.mediaRecorder.start();
    this.isRecording.set(true);
    this.isVoiceToVoiceChat.set(true);
    this.recordingStatus = 'Recording...';
    this.showEqualizer.set(true);
    this._cdr.markForCheck();
    // Setup Web Audio API
    this.audioContext = new AudioContext();
    const source = this.audioContext.createMediaStreamSource(stream);
    this.analyser = this.audioContext.createAnalyser();
    this.analyser.fftSize = 64;

    const bufferLength = this.analyser.frequencyBinCount;
    this.dataArray = new Uint8Array(bufferLength);

    source.connect(this.analyser);
    this.animateEqualizer();
  }
  animateEqualizer() {
    const canvas = this.canvasRef.nativeElement;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    const centerY = height / 2;
    
    // Waveform visualization properties
    const barWidth = 3; // Width of each bar
    const barSpacing = 3; // Space between bars (same as bar width)
    const totalBarWidth = barWidth + barSpacing;
    const numBars = Math.floor(width / totalBarWidth);
    const maxBarHeight = height * 0.6; // Decreased height
    const minBarHeight = 2;
    const dotSpacing = 12; // Increased spacing between dots
    const dotSize = 3; // Increased dot width
    
    // Audio history for waveform
    const waveformData: number[] = new Array(numBars).fill(0);
    const audioLevels: number[] = new Array(numBars).fill(0); // Store raw audio levels
    
    // Animation timing control
    let frameCount = 0;
    const updateFrequency = 2; // Update every 2 frames (slightly slower)
    
    const draw = () => {
      this.animationFrameId = requestAnimationFrame(draw);
      
      frameCount++;
      
      // Update waveform data every frame for high sensitivity
      if (frameCount % updateFrequency === 0) {
        // Get audio frequency data
        this.analyser.getByteFrequencyData(this.dataArray);
        
        // Calculate average audio level
        const average = this.dataArray.reduce((sum: number, value: number) => sum + value, 0) / this.dataArray.length;
        const normalizedLevel = (average / 255);
        
        // Shift existing data to the left (like a scrolling waveform)
        for (let i = 0; i < waveformData.length - 1; i++) {
          waveformData[i] = waveformData[i + 1];
          audioLevels[i] = audioLevels[i + 1];
        }
        
        // Add new audio data to the right with slightly reduced height sensitivity
        const hasAudio = normalizedLevel > 0.005; // Lower threshold for detection
        const intensityMultiplier = 1.5; // Slightly reduced intensity
        const newBarHeight = hasAudio ? 
          minBarHeight + (Math.pow(normalizedLevel, 0.8) * (maxBarHeight - minBarHeight) * intensityMultiplier) : 
          0;
        
        waveformData[waveformData.length - 1] = Math.min(newBarHeight, maxBarHeight);
        audioLevels[audioLevels.length - 1] = normalizedLevel;
      }
      
      // Clear canvas
      ctx!.clearRect(0, 0, width, height);
      
      // Check if there's any recent audio activity (stricter check for transition)
      const recentAudioActivity = audioLevels.some(level => level > 0.005);
      const hasSignificantBars = waveformData.some(height => height > minBarHeight);
      
      if (recentAudioActivity || hasSignificantBars) {
        // Set drawing style for bars
        ctx!.fillStyle = '#000000';
        
        // Draw waveform bars with rounded edges
        for (let i = 0; i < numBars; i++) {
          const x = i * totalBarWidth;
          const barHeight = waveformData[i];
          
          if (barHeight > minBarHeight) {
            // Draw rounded vertical bar centered on centerY
            const radius = barWidth / 2; // Radius is half the bar width
            const barTop = centerY - barHeight / 2;
            const barBottom = centerY + barHeight / 2;
            
            ctx!.beginPath();
            ctx!.moveTo(x + radius, barTop);
            ctx!.lineTo(x + barWidth - radius, barTop);
            ctx!.arc(x + barWidth - radius, barTop + radius, radius, -Math.PI/2, 0);
            ctx!.lineTo(x + barWidth, barBottom - radius);
            ctx!.arc(x + barWidth - radius, barBottom - radius, radius, 0, Math.PI/2);
            ctx!.lineTo(x + radius, barBottom);
            ctx!.arc(x + radius, barBottom - radius, radius, Math.PI/2, Math.PI);
            ctx!.lineTo(x, barTop + radius);
            ctx!.arc(x + radius, barTop + radius, radius, Math.PI, -Math.PI/2);
            ctx!.closePath();
            ctx!.fill();
          } else {
            // Draw small dot when bar height is minimal
            ctx!.beginPath();
            ctx!.arc(x + barWidth/2, centerY, 1, 0, Math.PI * 2);
            ctx!.fill();
          }
        }
      } else {
        // Draw dotted line when no audio
        ctx!.fillStyle = '#000000';
        
        for (let x = dotSpacing; x < width; x += dotSpacing) {
          ctx!.beginPath();
          ctx!.arc(x, centerY, dotSize, 0, Math.PI * 2);
          ctx!.fill();
        }
      }
    };
    
    draw();
  }

  drawRoundedRect(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number
  ) {
    const r = Math.min(radius, height / 2, width / 2); // Avoid over-rounding
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + r);
    ctx.lineTo(x + width, y + height - r);
    ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    ctx.lineTo(x + r, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
    ctx.fill();
  }
  closeRecording() {
    this.isRecording.set(false);
    this.recordingFinished.set(false);
    this.showEqualizer.set(false);
    this.audioUrl = null;
    this.base64Audio = null;
    this.isVoiceToVoiceChat.set(false);
    // Stop playback if any
    this.audioRef.nativeElement.pause();
    this.audioRef.nativeElement.src = ''; // Fully unload audio
    this.audioRef.nativeElement.load();

    // Stop equalizer animation
    this.stopPlaybackEqualizer();

    // Disconnect mediaElementSource if exists
    if (this.mediaElementSource) {
      try {
        this.mediaElementSource.disconnect();
      } catch (e) {
        console.warn('mediaElementSource already disconnected or invalid', e);
      }
      this.mediaElementSource = null;
    }

    // Close audioContext if not already closed
    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close().then(() => {
        this.audioContext = null;
      });
    }
  }

  stopPlaybackEqualizer() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = 0;
    }
  }
  async onPlay() {
    this.startPlaybackEqualizer();

    const audio = this.audioRef.nativeElement;

    try {
      // Resume audio context if suspended
      if (this.audioContext?.state === 'suspended') {
        await this.audioContext.resume();
      }

      await audio.play();
    } catch (err) {
      console.error('Playback error:', err);
    }
  }

  onPause() {
    const audioElement = this.audioRef?.nativeElement;
    if (audioElement) {
      audioElement.pause();
      this.onPauseOrEnd();
    }
  }

  onAudioPlay() {
    this.isAudioPlaying.set(true);
  }
  onPauseOrEnd() {
    this.isAudioPlaying.set(false);
    this.stopPlaybackEqualizer();
  }
  // Call this when user clicks play
  startPlaybackEqualizer() {
    if (!this.audioContext || this.audioContext.state === 'closed') {
      this.audioContext = new AudioContext();
      this.mediaElementSource = null; // Reset, since context is new
    }

    const audioElement = this.audioRef.nativeElement;

    if (!this.mediaElementSource) {
      this.mediaElementSource =
        this.audioContext.createMediaElementSource(audioElement);

      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 64;
      const bufferLength = this.analyser.frequencyBinCount;
      this.dataArray = new Uint8Array(bufferLength);

      this.mediaElementSource.connect(this.analyser);
      this.analyser.connect(this.audioContext.destination);
    }

    this.animateEqualizer();
  }
  scrollToBottom() {
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    }, 300);
  }
  getUsersLatestLocation() {
    this.accuracyList = []; // Array to store accuracy and coordinates
    const maxDuration = 2000; // 2 seconds
    const startTime = Date.now();
    const checkAccuracy = () => {
      if (this.accuracy != null) {
        // Check if the accuracy value already exists in the list
        const exists = this.accuracyList.some(
          (entry) => entry.accuracy === this.accuracy
        );
        if (!exists) {
          // Store accuracy with corresponding coordinates
          this.accuracyList.push({
            accuracy: this.accuracy,
            latitude: this.userLatitude,
            longitude: this.userLongitude,
          });
        }
      }
      // If accuracy is below the threshold, proceed
      if (this.accuracy != null && this.accuracy < 5) {
        // Calculate Distance
        const greenCenter =
          this.currentHole.hole.Greencenter?.Shapes?.Shape[0]?.Points.split(
            ' '
          );

        this.centerDistance = this.calculateDistance(
          this.userLatitude,
          this.userLongitude,
          +greenCenter[1],
          +greenCenter[0],
          this.customSetting.distance
        );
        return;
      }
      // Check if the maximum duration is exceeded
      if (Date.now() - startTime > maxDuration) {
        // Find the lowest accuracy value in the stored data
        const bestEntry = this.accuracyList.reduce((best, current) => {
          return current.accuracy < best.accuracy ? current : best;
        });
        this.userLatitude = bestEntry.latitude;
        this.userLongitude = bestEntry.longitude;
        // Calculate Distance
        const greenCenter =
          this.currentHole.hole.Greencenter?.Shapes?.Shape[0]?.Points.split(
            ' '
          );

        this.centerDistance = this.calculateDistance(
          this.userLatitude,
          this.userLongitude,
          +greenCenter[1],
          +greenCenter[0],
          this.customSetting.distance
        );
      }
      // Retry if the duration is within the limit
      setTimeout(checkAccuracy, this.retryDelay);
    };
    checkAccuracy();
  }
  sendAudioToTextQuestion() {
    this.questionModel = new AskQuestionModel();
    this.questionModel.chatId = this.chatId;

    // Use data from watchPosition
    this.questionModel.clientLocation = `${this.userLatitude},${this.userLongitude}`;
    this.questionModel.holeNumber = this.currentHole.hole.HoleNumber;
    this.questionModel.courseId = this.id;
    this.questionModel.processType = 'QA-ON-COURSE';
    this.questionModel.textQuestion = this.textQuestion;
    this._chatService.askQuestionV2(this.questionModel);
  }
  autoResize(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 200) + 'px';
  }
  ngOnDestroy(): void {
    if (!this.endRoundClicked) {
      const leaveTime = new Date().toISOString();
      localStorage.setItem('onCourseLeaveTime', leaveTime);
    } else {
      localStorage.removeItem('onCourseLeaveTime');
      localStorage.removeItem('HoleNumber');
      localStorage.removeItem('onCourseId');
      localStorage.removeItem('OnCourseChatId');
    }
    if (this.watchId !== null) {
      navigator.geolocation.clearWatch(this.watchId); // Stop geolocation tracking
    }
    // this._chatService.disconnectWebSocket();
  }
}
